import { Button } from '@progress/kendo-react-buttons';
import { GridCellProps } from '@progress/kendo-react-grid';
import React, { useState } from 'react';
import { GearGridCell } from './GearGridCell';
import { hyperlinkOpenIcon, clockArrowRotateIcon } from '@progress/kendo-svg-icons';
import { EMPTY_VALUE } from '../../../config/consts';
import { DocumentVersionViewer } from '../DocumentVersionViewer';
import { useCurrentUserContext } from '../../../context/currentUser/CurrentUserContext';

interface LinkedCellProps extends GridCellProps {
  onLinkClicked: () => void;
  title?: string;
  value?: string;
  documentId?: string;
  documentName?: string;
  contentType?: string;
}

export const LinkedCell: React.FC<LinkedCellProps> = props => {
  const { selectedIndex } = useCurrentUserContext();
  const [isVersionViewerOpen, setIsVersionViewerOpen] = useState(false);
  const field = props.field || EMPTY_VALUE;
  const value = props.value || props.dataItem[field];
  const title = props.title || value?.toString();

  const handleOpenVersionViewer = () => {
    setIsVersionViewerOpen(true);
  };

  const handleCloseVersionViewer = () => {
    setIsVersionViewerOpen(false);
  };

  return (
    <GearGridCell {...props} title={title}>
      <div className="linkedCell">
        <Button svgIcon={hyperlinkOpenIcon} title={value?.toString()} size='small' fillMode="link" onClick={props.onLinkClicked}>
          {value?.toString() || EMPTY_VALUE}
        </Button>
        {selectedIndex?.supportsVersioning && props.documentId && props.documentName && props.contentType && (
          <Button
            svgIcon={clockArrowRotateIcon}
            title="Open version history"
            size='small'
            fillMode="link"
            onClick={handleOpenVersionViewer}
          />
        )}
      </div>

      {selectedIndex?.supportsVersioning && props.documentId && props.documentName && props.contentType && (
        <DocumentVersionViewer
          isOpen={isVersionViewerOpen}
          onClose={handleCloseVersionViewer}
          documentId={props.documentId}
          documentName={props.documentName}
          contentType={props.contentType}
        />
      )}
    </GearGridCell>
  );
};
